<template>
  <div
    v-if="isStage || isSmoke"
    class="core-line-stage text-h6 py-1 text-center"
  >
    {{ text }}
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from 'vue'

const isStage = process.env.IS_STAGE || (typeof window === 'object' && window.location.href.includes('stage')) // ToDo Избавиться от костыля с проверкой 'location.href'
const isSmoke = process.env.IS_SMOKE || (typeof window === 'object' && window.location.href.includes('smoke')) // ToDo Избавиться от костыля с проверкой 'location.href'

const text: ComputedRef<string> = computed(() => {
  if (isStage) {
    return 'Stage'
  }

  if (isSmoke) {
    return 'Smoke'
  }

  return ''
})
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.core-line-stage {
  background-color: $ui-kit-error;
  bottom: 0;
  color: $ui-kit-bg-gray-0;
  left: 0;
  opacity: .96;
  pointer-events: none;
  position: fixed;
  text-transform: uppercase;
  width: 100vw;
  z-index: 9999999;
}
</style>
